import React from "react";

export type BottomSheetContent = "CTA" | "FORM" | "DOWNLOAD" | "THANKS";

type BottomSheetContextType = {
  open: boolean;
  content: BottomSheetContent;
  selectedCtaIndex: number;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setContent: React.Dispatch<React.SetStateAction<BottomSheetContent>>;
  setSelectedCtaIndex: React.Dispatch<React.SetStateAction<number>>;
  openBottomSheet: (content: BottomSheetContent, ctaIndex?: number) => void;
};

export const BottomSheetContext = React.createContext<
  BottomSheetContextType | undefined
>(undefined);

export function useBottomSheet() {
  const context = React.useContext(BottomSheetContext);
  if (!context) {
    throw new Error("useBottomSheet must be used within BottomSheetProvider");
  }
  return context;
}
